import React, { useState } from "react";
import styled from "styled-components";

import Button from "../components/Button";
import Input from "../components/Input";

import { useHistory } from "react-router-dom";

import DefaultLayout from "../layouts/DefaultLayout";

import { signUp } from "../firebase/firebase.utils";

const SubscribePage = ({ currentUser, themeToggler, theme }) => {
  const history = useHistory();
  const [email, setEmail] = useState(null);
  const [password, setPassword] = useState(null);

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };

  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
  };

  const login = async (e) => {
    e.preventDefault();
    await signUp(email, password);
    history.push("/subscribe");
  };

  return (
    <DefaultLayout themeToggler={themeToggler} theme={theme}>
      <PageBody>
        <FormContainer>
          <FormTitle>Sign Up to TubeDiary</FormTitle>
          <LoginForm>
            <Input value={email} onChange={handleEmailChange} label="Email" />
            <Input
              value={password}
              onChange={handlePasswordChange}
              label="Password"
            />
            <Button label="Sign Up" onClick={login} />
          </LoginForm>
        </FormContainer>
      </PageBody>
    </DefaultLayout>
  );
};

export default SubscribePage;

const FormTitle = styled.span`
  font-size: 2rem;
  font-weight: 700;
`;

const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;
const LoginForm = styled.form`
  width: 33%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const PageBody = styled.div`
  width: 100%;
  max-width: 1440px;
  margin: 0 auto;
`;
